import { Tuti } from '../../tuti/js/Tuti';
import slider from './modules/slider';
import scrollTop from './modules/scrollTop';
import burger from '././modules/burger';

Tuti.ready(() => {
  slider();
  scrollTop();
  burger();
});
